import { useDispatch, useSelector } from 'react-redux';
import {
	Checkbox,
	IconButton,
	TableBody,
	TableCell,
	TableRow,
	Typography,
} from 'styles';
import { getShortDate } from 'utils/utils';

import { ReactComponent as ChevronRightIcon } from 'assett/icons/chevron_right_icon.svg';
import { setSelectOne } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { IClaims } from 'types/Claims';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { StatusIcon } from './StatusIcon.component';

export const ClaimsBody = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const { claims } = useSelector((store: RootState) => store.claims);
	const { selectedItems, downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);
	const navigate = useNavigate();
	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);

	const handleClick = (uuid: string) => {
		navigate(`/view-claims/${uuid}`);
	};

	const { networks } = useSelector((store: RootState) => store.form);

	const dispatch = useDispatch<AppDispatch>();

	const List = claims?.map((claim: IClaims) => {
		return (
			<TableRow key={claim.claimUUID}>
				<TableCell sx={{ width: 44 }}>
					<Checkbox
						label=""
						key={claim.claimUUID}
						sx={{ p: 0, ml: 0 }}
						checked={
							downloadAll
								? !selectedItems.find((el: string | number) => el === claim.claimUUID)
								: !!selectedItems.find((el: string | number) => el === claim.claimUUID)
						}
						onClick={() => {
							dispatch(setSelectOne(claim.claimUUID));
						}}
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{`#${claim.externalClaimId}`}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{claim.claimCarrierIntegrationInfo.carrierClaimId
							? `${claim.claimCarrierIntegrationInfo.carrierClaimId}`
							: '-'}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{claim.clientName ? `${claim.clientName}` : '-'}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{claim.memberFirstName}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{claim.memberLastName}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{getShortDate(claim.claimDate)}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						<StatusIcon status={claim.status.id} />
						{tDbLabels(claim.status.label)}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{claim.memberProviderLocation}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{tDbLabels(
							`${
								claim.claimInNetwork
									? 'network_status.INN.short'
									: 'network_status.OON.short'
							}`,
						)}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{networks.find(network => network.networkCode === claim.networkCode)
							?.name || '-'}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{tDbLabels(claim?.returnDetail?.statusLabel ?? 'return_status.no-return')}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{tClientLabels(`commons.${claim?.hasComplaint ? 'yes' : 'no'}`)}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{tClientLabels(`commons.${claim?.hasFraud ? 'yes' : 'no'}`)}
					</Typography>
				</TableCell>
				<TableCell />
				<TableCell>
					<IconButton onClick={() => handleClick(claim.claimUUID)}>
						<ChevronRightIcon />
					</IconButton>
				</TableCell>
			</TableRow>
		);
	});

	return List && List.length > 0 ? (
		<TableBody>{List}</TableBody>
	) : List && !progressIndicator?.isLoading ? (
		<TableBody
			sx={{
				'& td': {
					paddingLeft: '0px!important',
					textAlign: 'left!important',
					backgroundColor: 'transparent!important',
				},
			}}
		>
			<TableRow>
				<TableCell colSpan={12}>
					<Typography variant="bodyLink" sx={{ width: '100%' }}>
						{tClientLabels('view-claims.noClaimsFound')}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	) : null;
};
